var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.havePermission)?_c('div',[_c('FileManager',{attrs:{"inline":""}}),_c('ImageFilter')],1):_c('h3',{staticClass:"tc"},[_vm._v("You don't have permission")])])
}
var staticRenderFns = []

export { render, staticRenderFns }